import React from 'react';
import './Hero.css';
import { Code, Sparkles, ArrowDown } from 'lucide-react';

const Hero = () => {
  const scrollToProjects = () => {
    const element = document.getElementById('projects');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="hero">
      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-badge">
            <Sparkles size={16} />
            <span>Welcome to NA Code Studio</span>
          </div>
          
          <h1 className="hero-title">
            Crafting Digital
            <span className="gradient-text"> Excellence</span>
          </h1>
          
          <p className="hero-description">
            Transforming ideas into innovative digital solutions. 
            Explore my portfolio of cutting-edge projects built with passion and precision.
          </p>
          
          <div className="hero-buttons">
            <button className="btn-primary" onClick={scrollToProjects}>
              View Projects
              <ArrowDown size={18} />
            </button>
            <a href="#contact" className="btn-secondary">
              Get In Touch
            </a>
          </div>
        </div>
        
        <div className="hero-visual">
          <div className="code-block">
            <Code size={64} className="code-icon" />
            <div className="code-lines">
              <div className="code-line"></div>
              <div className="code-line"></div>
              <div className="code-line"></div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="scroll-indicator">
        <div className="scroll-line"></div>
      </div>
    </section>
  );
};

export default Hero;



